import { getBrands, getCategory, getProducts } from '@/apis/base';

const PAGE_SIZE = 20;
const PAGE_INDEX = 1;

export default {
  namespaced: true,
  state: () => {
    return {
      category: {
        list: []
      },
      brand: {
        list: []
      },
      product: {
        list: [],
        pageInfo: {
          pageIndex: PAGE_INDEX,
          pageSize: PAGE_SIZE
        },
        loading: false
      },
      currentBrandId: '',
      currentClassId: ''
    };
  },
  mutations: {
    setCategories (state, payload) {
      state.category.list = payload;
    },
    setBrands (state, payload) {
      state.brand.list = payload;
    },
    setProducts (state, payload) {
      state.product.list = payload;
    },
    setPageInfo (state, payload) {
      state.product.pageInfo = payload;
    },
    setProLoadingSta (state, sta) {
      state.product.loading = sta;
    },
    setCurrentClass (state, classId) {
      state.currentClassId = classId;
    },
    setCurrentBrand (state, brandId) {
      state.currentBrandId = brandId;
    }
  },
  getters: {
    brandName (state) {
      const brand = state.brand.list.find(
        element => +element.brandId === +state.currentBrandId
      );
      return brand ? brand.brandName : '热门';
    },
    className (state) {
      const result = state.category.list.find(
        element => +element.classId === +state.currentClassId
      );
      return result ? result.className : '手机';
    }
  },
  actions: {
    async fetchPageData ({ commit }, { classid, brandid, pageIndex = PAGE_INDEX, pageSize = PAGE_SIZE }) {
      commit('setProLoadingSta', true);
      try {
        let res = await getCategory();
        commit('setCategories', res._data.classList);
        if (!classid) {
          classid = res._data.classList[0].classId;
        }
        commit('setCurrentClass', classid);
      } catch (e) {
        console.log(e);
      }

      try {
        let res = await getBrands(classid);
        commit('setBrands', res._data.brandList);
        if (!brandid) {
          brandid = res._data.brandList[0].brandId;
        }
        commit('setCurrentBrand', brandid);
      } catch (e) {
        console.log(e);
      }

      try {
        const res = await getProducts(classid, brandid, pageIndex, pageSize);
        const list = res._data.productList;
        const pageInfo = res._data.pageInfo;
        commit('setProducts', list);
        commit('setPageInfo', pageInfo);
      } catch (e) {
        console.log(e);
      }
      commit('setProLoadingSta', false);
    },

    async handleBrandItemClick ({ commit, state }, brand) {
      commit('setCurrentBrand', brand.brandId);
      const classId = state.currentClassId;
      const brandId = state.currentBrandId;

      try {
        const res = await getProducts(classId, brandId, PAGE_INDEX, PAGE_SIZE);
        const list = res._data.productList;
        const pageInfo = res._data.pageInfo;
        commit('setProducts', list);
        commit('setPageInfo', pageInfo);
      } catch (e) {
        console.log(e);
      }
    },

    async handleCategoryItemClick ({ commit, state, dispatch }, category) {
      const classId = category.classId;
      commit('setCurrentClass', classId);

      try {
        let res = await getBrands(classId);
        const brandId = res._data.brandList[0].brandId;
        commit('setBrands', res._data.brandList);
        commit('setCurrentBrand', brandId);
        dispatch('getProductList');
      } catch (e) {
        console.log(e);
      }
    },

    async getProductList ({ commit, state }) {
      const classId = state.currentClassId;
      const brandId = state.currentBrandId;
      const { pageIndex, pageSize } = state.product.pageInfo;
      try {
        const res = await getProducts(classId, brandId, pageIndex, pageSize);
        const list = res._data.productList;
        const pageInfo = res._data.pageInfo;
        commit('setProducts', list);
        commit('setPageInfo', pageInfo);
      } catch (e) {
        console.log(e);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/models/store.js